export class VideoController {
    constructor(videoElement) {
        // Accept either a string ID or the DOM element itself
        this.video = typeof videoElement === 'string' 
            ? document.getElementById(videoElement) 
            : videoElement;

        if (!this.video) {
            console.error("VideoController: Element not found.");
        }
    }

    // Standard Play/Pause toggle
    togglePlay() {
        if (this.video.paused || this.video.ended) {
            this.play();
        } else {
            this.pause();
        }
    }

    play() {
        this.video.play().catch(error => {
            console.warn("Playback failed. (Likely due to browser autoplay policies):", error);
        });
    }

    pause() {
        this.video.pause();
    }

    // Reset and play from the start
    replay() {
        this.video.currentTime = 0;
        this.play();
    }

    // Jump forward or backward (seconds)
    seek(seconds) {
        this.video.currentTime += seconds;
    }

    // Set volume (0.0 to 1.0)
    setVolume(value) {
        this.video.volume = Math.min(Math.max(value, 0), 1);
    }
}